export enum HTTP_ACCOUNT_EVENT {
  /**
   * Pays an open account and closes it
   */
  pay = '/api/checkout',
}
